enum StripeBillingPortalType {
  CANCEL_COACHING_SUBSCRIPTION = "cancel_coaching_subscription",
  CANCEL_REPORT_SUBSCRIPTION = "cancel_report_subscription",
  VIEW_INVOICES = "view_invoices",
  VIEW_MANAGE_BILLING = "view_manage_billing",
  UPDATE_PAYMENT_METHOD = "update_payment_method",
  CHANGE_PLAN = "change_plan"
}

export const StripeBillingPortalTypeValues: StripeBillingPortalType[] = [
  StripeBillingPortalType.CANCEL_COACHING_SUBSCRIPTION,
  StripeBillingPortalType.CANCEL_REPORT_SUBSCRIPTION,
  StripeBillingPortalType.VIEW_INVOICES,
  StripeBillingPortalType.VIEW_MANAGE_BILLING,
  StripeBillingPortalType.UPDATE_PAYMENT_METHOD,
  StripeBillingPortalType.CHANGE_PLAN
]

export default StripeBillingPortalType
